import { ReactElement } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { useReachGoal } from '@/hooks/useReachGoal'

import banner from './images/banner.webp'
import min from './images/min.webp'
import wide from './images/wide.webp'
import styles from './styles.module.scss'

export default function SurveyBanner(): ReactElement {
    const reachGoal = useReachGoal()

    const pathname = usePathname()

    return (
        <div className={styles.wrapper}>
            <Link
                href={'/survey'}
                target={'_blank'}
                className={styles.banner}
                onClick={() =>
                    reachGoal({
                        type: 'params',
                        goalName: 'click-banner-survey',
                        params: {
                            url: pathname,
                        },
                    })
                }
            >
                <Image
                    src={banner}
                    alt={'Пройди опрос'}
                    className={styles.banner__image}
                    draggable={false}
                />
                <Image
                    src={wide}
                    alt={'Пройди опрос'}
                    className={styles.banner__wide}
                    draggable={false}
                />
                <Image
                    src={min}
                    alt={'Пройди опрос'}
                    className={styles.banner__min}
                    draggable={false}
                />
            </Link>
        </div>
    )
}
